if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			const productSlider = new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 0,
				observer: true,
				observeParents: true,
				observeSlideChildren: true,
				// Swiper's own ResizeObserver re-measures the slides when the viewport
				// changes (observeParents/MutationObserver does NOT catch resize-driven
				// size changes), so the slide width stays exact after resizing.
				resizeObserver: true,
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});

			// Recalc once the layout / lazy images settle so Swiper measures each slide
			// correctly. NOTE: the "strip of the next photo" fix lives in
			// muv-overrides.css — `.product-card-js .swiper-slide { width: round(100%,1px) }`
			// rounds the slide to a whole pixel so it matches Swiper's integer offsetWidth
			// (otherwise a ~0.25px sliver of the next photo peeked when sliding).
			requestAnimationFrame(() => productSlider.update());
			slider.querySelectorAll("img").forEach((img) => {
				if (!img.complete) {
					img.addEventListener("load", () => productSlider.update(), { once: true });
				}
			});
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	const refreshAllSliders = () => {
		document.querySelectorAll(".product-card-js").forEach(function (s) {
			if (s.swiper) s.swiper.update();
		});
	};

	// Once the page fully loads (all lazy images), refresh every slider.
	window.addEventListener("load", refreshAllSliders);

	// Recalc on every viewport resize so the slide width stays exact (and the
	// rounded width re-evaluates against the new container).
	let rafResize = null;
	window.addEventListener("resize", function () {
		if (rafResize) cancelAnimationFrame(rafResize);
		rafResize = requestAnimationFrame(refreshAllSliders);
	});
	window.addEventListener("orientationchange", refreshAllSliders);

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
